/** Tiny pub/sub so Settings (and similar) can refresh all `useShopPreferences` subscribers. */

type Listener = () => void

const listeners = new Set<Listener>()

export function subscribeShopContextRefresh(listener: Listener): () => void {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}

export function notifyShopContextRefresh(): void {
  listeners.forEach((listener) => {
    try {
      listener()
    } catch (err) {
      console.error('shopContextRefresh listener failed:', err)
    }
  })
}
